import { EMPTY, type Move } from './types.js';
import { parseSquare, squareName } from './squares.js';

const PROMOTION_LETTERS = ['', '', 'n', 'b', 'r', 'q'];

/** "e2e4", "e7e8q". The wire and record format for a move. */
export function moveToUci(move: Move): string {
  return `${squareName(move.from)}${squareName(move.to)}${PROMOTION_LETTERS[move.promotion] ?? ''}`;
}

/** The move in `moves` matching a UCI string, if any. */
export function findUciMove(moves: readonly Move[], uci: string): Move | undefined {
  const from = parseSquare(uci.slice(0, 2));
  const to = parseSquare(uci.slice(2, 4));
  const promoLetter = uci.slice(4);
  const promotion = promoLetter === '' ? EMPTY : PROMOTION_LETTERS.indexOf(promoLetter);
  if (promotion < 0) return undefined;
  return moves.find((m) => m.from === from && m.to === to && m.promotion === promotion);
}
